import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AuthService, LaunchDarklyUserGuard } from 'remarketing-angular-library';

/**
 * Guard that matches when the SIM V2 flag is Enabled
 * Used for Seller Inventory Management V2 elastic search
 * If this guard returns false, the legacy Manage Inventory route (without a guard) will be the fallback.
 */
export const inventoryManagementVersionGuard: CanMatchFn = () => {
  const authService = AuthService.getInstance();

  if (!authService.isAuthenticated()) {
    return true;
  }

  return inject(LaunchDarklyUserGuard).canMatch('sim-v2Enabled');
};
